module.exports = __webpack_public_path__ + "static/media/arrow-left.3ddb7ed5.svg";